<template>
  <div class="form-group">
    <label v-if="label" class="font-size-12">{{ label }}</label>
    <div class="input-container d-flex">
      <input v-model="iValue" :disabled="loadingUpload" type="text" class="form-control" placeholder="https://example.com" :style="{ flex: '1 1 auto' }" />
      <button :disabled="loadingUpload" class="btn-upload" title="Upload" @click="selectFile">
        <b-spinner v-if="loadingUpload" small />
        <i v-else :class="uploadIcon" />
      </button>
      <button :disabled="loadingUpload" class="btn-upload btn-remove" title="Delete" @click="removeImage">
        <i :class="deleteIcon" />
      </button>
      <input ref="inputFile" type="file" name="upload" :style="{ display: 'none' }" accept="image/*" @change="uploadFile($event)" />
    </div>
  </div>
</template>

<script>
import { DELETE_ICON, UPLOAD_ICON } from '@src/icons'
export default {
  props: {
    label: { type: [String], default: '' },
    options2: { type: [Object], default: null, required: true },
    elementId: { type: String, default: null, required: true },
    valueKey: { type: String, default: null, required: true }
  },
  data() {
    return {
      deleteIcon: DELETE_ICON,
      uploadIcon: UPLOAD_ICON,
      timer: null
    }
  },
  computed: {
    canLoad() {
      if (this.options2[this.elementId] && this.options2[this.elementId].hasOwnProperty(this.valueKey)) {
        return true
      }
      return false
    },
    imageUploadStatus2: {
      get() { return this.$store.getters['utility/imageUploadStatus2'] },
      set(value) { this.$store.dispatch('utility/setImageUploadStatus2', value) }
    },
    loadingUpload() {
      return this.imageUploadStatus2[`${this.elementId}:${this.valueKey}`] || false
    },
    iValue: {
      get() {
        return this.options2[this.elementId][this.valueKey]
      },
      set(newVal) {
        this.options2[this.elementId][this.valueKey] = newVal
        this.options2[this.elementId].ShowWidth = null
        this.options2[this.elementId].ShowHeight = null
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          let that = this
          let img = new Image()
          img.onload = function() {
            let width = this.width
            let height = this.height
            if (width > 300) {
              height = parseFloat(300 * height / width)
              width = 300
            }
            if (height > 60) {
              width = parseFloat(60 * width / height)
              height = 60
            }
            width = parseInt(width)
            height = parseInt(height)
            that.options2[that.elementId].ShowWidth = width
            that.options2[that.elementId].ShowHeight = height
          }
          img.src = newVal
        }, 500)
      }
    }
  },
  methods: {
    setImageUploadStatus2(value) {
      this.imageUploadStatus2 = value
    },
    selectFile() {
      this.$refs.inputFile.click()
    },
    uploadFile(event) {
      if (!event.target.files.length) return

      let imageParams = new FormData()
      imageParams.append('file', event.target.files[0])
      imageParams.append('elementId', this.elementId)
      imageParams.append('valueKey', this.valueKey)

      this.setImageUploadStatus2({
        ...this.imageUploadStatus2,
        [`${this.elementId}:${this.valueKey}`]: true
      })
      this.$store
        .dispatch('image/uploadLogoImage', imageParams)
        .then((response) => {
          if (response.url && this.options2 && this.options2[response.elementId]) {
            this.options2[response.elementId][response.valueKey] = response.url
            this.options2[response.elementId].ShowWidth = response.ShowWidth || null
            this.options2[response.elementId].ShowHeight = response.ShowHeight || null
          }
          this.setImageUploadStatus2({
            ...this.imageUploadStatus2,
            [`${response.elementId}:${response.valueKey}`]: false
          })
        })
        .catch((callParams) => {
          const elementId = callParams.get('elementId')
          const valueKey = callParams.get('valueKey')
          this.setImageUploadStatus2({
            ...this.imageUploadStatus2,
            [`${elementId}:${valueKey}`]: false
          })
        })
    },
    removeImage() {
      this.options2[this.elementId][this.valueKey] = null
      this.options2[this.elementId].ShowWidth = null
      this.options2[this.elementId].ShowHeight = null
    }
  }
}
</script>